import React from 'react'
import styled from 'styled-components';
import { connect } from 'react-redux';

const Container = styled.div`
  background: white;
  height: 65px;
  color: black;
`;

const Content = styled.div`
  max-width: 1024px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
`;

const PoweredLabel = styled.div`
  font-size: 8px;
`;

const PoweredName = styled.a`
  font-size: 10px;
  color: black;
`;

const Copyright = styled.div`
  font-size: 10px;
`;


function Footer({ pageInfo } : { pageInfo: Object }) {
  console.log(pageInfo);
  return (
    <Container>
      <Content>
        <Copyright>
          © {new Date().getFullYear()} - {pageInfo && pageInfo.page.title && pageInfo.page.title.toUpperCase()}
        </Copyright>
        <div>
          <PoweredLabel>POWERED BY</PoweredLabel>
          <PoweredName href="https://inmoblex.com">INMOBLEX.COM</PoweredName>
        </div>
      </Content>
    </Container>
  )
}

export default connect(state => ({
  pageInfo: state.client.pageInfo,
}))(Footer);


// WEBPACK FOOTER //
// ./src/components/Footer/index.js